/**
 * Re-insert the deployment subpath into an absolute URL built by the server.
 *
 * The server composes external links by resolving a root-absolute path against
 * the request *origin* (see `URLHelper.url`), which silently drops the subpath
 * the server itself is mounted under (AFFINE_SERVER_SUB_PATH). On a subpath
 * deployment that produces links such as `http://host/invite/<id>` instead of
 * `http://host/mindmap/invite/<id>` — links that land on whatever else is hosted
 * at the domain root.
 *
 * `environment.subPath` is injected into the HTML at build time.
 */
export function withSubPathUrl(link: string): string {
  const subPath = environment.subPath || '';
  if (!subPath || !link) {
    return link;
  }

  try {
    const url = new URL(link);
    if (url.pathname !== subPath && !url.pathname.startsWith(`${subPath}/`)) {
      url.pathname = `${subPath}${url.pathname}`;
    }
    return url.toString();
  } catch {
    return link;
  }
}
